module.exports = __webpack_public_path__ + "static/img/110115.318916ee.png";